import { recallShare, rememberShare } from './poolShareMemory';

export const POOL_STRATEGY_OPTIONS = [
  { value: 'explicit', label: 'Explicit' },
  { value: 'remainder', label: 'Remainder' },
  { value: 'equal_share_of_remainder', label: 'Equal share of remainder' },
  { value: 'percentage_of_remainder', label: 'Percentage of remainder' },
  { value: 'percentage_of_gross', label: 'Percentage of gross' },
];

const SHARE_BASE_BY_STRATEGY = {
  percentage_of_remainder: 'remainder',
  percentage_of_gross: 'gross',
};

const SHARE_LABEL_BY_BASE = {
  pool: 'Share of pool',
  remainder: 'Share of remainder',
  gross: 'Share of gross',
};

const SHARE_READING_STRATEGIES = ['explicit', 'percentage_of_remainder', 'percentage_of_gross'];

export const shareBaseFor = (strategy) => SHARE_BASE_BY_STRATEGY[strategy] || 'pool';

export const readsShare = (strategy) => SHARE_READING_STRATEGIES.includes(strategy);

export const shareLabelFor = (strategy) => SHARE_LABEL_BY_BASE[shareBaseFor(strategy)];

export const changesShareBase = (from, to) => shareBaseFor(from) !== shareBaseFor(to);

export const restateShare = ({ offerId, from, to, share }) => {
  rememberShare(offerId, shareBaseFor(from), share);
  if (to === 'percentage_of_remainder') return 100;
  return recallShare(offerId, shareBaseFor(to));
};
